import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ChevronLeftIcon } from '@iris/react-icons/ChevronLeftIcon';
import { ChevronRightIcon } from '@iris/react-icons/ChevronRightIcon';
import carouselButtonStyles from './CarouselButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * CarouselButton component for navigating carousel content
 */
const CarouselButton = forwardRef((_a, ref) => {
    var { direction, variant = "floating", inverse = false, className, "aria-label": ariaLabel } = _a, props = __rest(_a, ["direction", "variant", "inverse", "className", "aria-label"]);
    const { button, icon, wrapper } = carouselButtonStyles({
        variant,
        inverse,
        direction,
    });
    const defaultAriaLabel = direction === "left" ? "Go to Previous Item" : "Go to Next Item";
    const Icon = direction === "left" ? ChevronLeftIcon : ChevronRightIcon;
    return (jsx("button", Object.assign({ ref: ref, "aria-label": ariaLabel || defaultAriaLabel, className: cn(button(), className) }, props, { children: jsx("div", { className: wrapper(), children: jsx(Icon, { "aria-hidden": "true", className: icon() }) }) })));
});
CarouselButton.displayName = "CarouselButton";

export { CarouselButton };
